import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { OverlayModule } from '@angular/cdk/overlay';

// External Libraries
import { MtxButtonModule } from '@ng-matero/extensions/button';

// HTTP
import { HttpClientModule } from '@angular/common/http';
import { HttpInteceptorModule } from './http/http-interceptor.module';

// Library Stuff
import { DialogsModule, MaterialsModule } from '@library/common';
import { PipesModule } from '@library/core/pipes';
import { AuthModule } from '@library/modules/auth';
import { UserAccessGuard } from '@library/modules/user';
import { ErrorsModule } from '@library/modules/errors';

// App Specific
import { AppRoutingModule } from './app.routing';

import { AppComponent } from './app.component';

import { AppMenuModule } from './components/menu/menu.module';

@NgModule( {
   declarations: [
      AppComponent,
   ],
   imports: [
      BrowserAnimationsModule,
      BrowserModule,
      FormsModule, ReactiveFormsModule,
      HttpClientModule,
      RouterModule,

      OverlayModule,

      // External Libraries
      MtxButtonModule,

      // HTTP
      HttpInteceptorModule,

      // Library
      AuthModule,
      DialogsModule,
      ErrorsModule,
      MaterialsModule,
      PipesModule,

      // App
      AppMenuModule,
      AppRoutingModule,
   ],
   providers: [
      // Guards
      UserAccessGuard,

      Validators,
   ],
   bootstrap: [ AppComponent ]
} )
export class AppModule {
}
